import type { UseQueryOptions } from '@tanstack/react-query';

/**
 * Opções para queries de comissão/parcelas que outros agentes podem alterar
 * enquanto a tela fica aberta.
 *
 * - Foco na aba: refetch se os dados estiverem stale
 * - Polling leve só com a aba visível (não em background)
 *
 * Não cobre realtime instantâneo (não há Echo/WebSocket no Hub).
 */
export const COMMISSION_LIVE_QUERY = {
    staleTime: 15_000,
    refetchOnWindowFocus: true,
    refetchInterval: 45_000,
    refetchIntervalInBackground: false,
} as const satisfies Partial<UseQueryOptions>;

/** Home do vendedor: mês em paralelo com o perfil, sem poll de 45s. */
export const COMMISSION_HOME_MONTH_QUERY = {
    staleTime: 120_000,
    refetchOnWindowFocus: true,
    refetchInterval: false,
    refetchIntervalInBackground: false,
} as const satisfies Partial<UseQueryOptions>;
